export const compileModal = {
  IconButton: {
    icon: 'crossmark',
    padding: 'Y2',
    position: 'absolute',
    top: 'X',
    right: 'X',
    // eslint-disable-next-line no-restricted-syntax -- icon-only close button, not text
    color: 'inactive',
    onClick: (ev, el, s, ctx) => el.call('closeRouterModal')
  },
  Compile: {
    extends: '/compile',
    Flex_header: {
      padding: '0 C1 X A'
    }
  },
  props: {
    align: 'stretch',
    theme: 'modal',
    gap: 'A',
    width: '100%',
    padding: 'X X X',
    height: '100%'
  }
}
